// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"248":"e394d1c7","327":"e394d1c7","387":"48f2b0c6","619":"81527b01","954":"81527b01"}[chunkId] + ".css";
};